export enum TypeAttestDom {
	PERSO = 'PERSO',
	TIERS = 'TIERS'
}